import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { FLUSH, PAUSE, PERSIST, persistReducer, persistStore, PURGE, REGISTER, REHYDRATE } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { apiSlice } from '../api/apiSlice';
import reducer from './slices/auth';
import clientReducer from './slices/client';
import toasterReducer from './slices/toaster';
import vaultiLakeReducer from './slices/vaultilake';
import vaultiCrawlReducer from './slices/vaulticrawl';
import notificationReducer from './slices/notificationSlice';
import customFieldReducer from './slices/customField';
import selectedIntegrationReducer from './slices/integration';

const appReducer = combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,
  auth: reducer,
  client: clientReducer,
  toaster: toasterReducer,
  vaultilake: vaultiLakeReducer,
  vaulticrawl: vaultiCrawlReducer,
  notifications: notificationReducer,
  customField: customFieldReducer,
  selectedIntegration: selectedIntegrationReducer,
});

export type RootState = ReturnType<typeof appReducer>;
const rootReducer = (state: RootState | undefined, action: any) => {
  if (action.type === 'RESET') {
    state = undefined;
  }

  return appReducer(state, action);
};

const persistConfig = {
  key: 'root',
  version: 1,
  storage: storage,
  blacklist: ['alert', apiSlice.reducerPath],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        ignoredActionPaths: ['payload', 'meta.arg', 'meta.baseQueryMeta'],
        ignoredPaths: ['api.queries', 'api.mutations'],
      },
    }).concat(apiSlice.middleware),
});

export const persistor = persistStore(store);
export default store;
